// src/services/indexedDb.js
export const IndexedDB = {
  async init() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('kogoApp', 1)

      request.onerror = () => reject(request.error)
      request.onsuccess = () => resolve(request.result)

      request.onupgradeneeded = (event) => {
        const db = event.target.result
        if (!db.objectStoreNames.contains('appData')) {
          db.createObjectStore('appData')
        }
      }
    })
  },

  async getItem(key) {
    const db = await this.init()
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(['appData'], 'readonly')
      const store = transaction.objectStore('appData')
      const request = store.get(key)

      request.onerror = () => reject(request.error)
      request.onsuccess = () => resolve(request.result)
    })
  },

  async setItem(key, value) {
    const db = await this.init()
    return new Promise((resolve, reject) => {
      const transaction = db.transaction(['appData'], 'readwrite')
      const store = transaction.objectStore('appData')
      const request = store.put(value, key)

      request.onerror = () => reject(request.error)
      request.onsuccess = () => resolve(request.result)
    })
  },
}
